/**
 * Created by Kevin Dench on 6/15/2016.
 */
/* @ngInject */
export default function SimilarPartsApiService($resource, $http, __env) {
    return {
        similarPartsCompare: function (similarPartsInput, callBack) {
            $http.post(
                `${__env.intellidataApiUrl}similar`,
                similarPartsInput
            ).then(({data}) => {
                callBack(data);
            })['catch'](function (errorData, status) {
                console.error(status);
            });
        }
    };
}
